import { StyledTextField, StyledRightContainer, StyledLeftContainer } from "./text-field.style";
import { MDSTextFieldProps, MDSTextFieldSlotName } from "./text-field.types";
import { getSlot } from "@/mds/utils/slots";
import { Input, TextArea } from "react-aria-components";

export const MDSTextField = ({
  children,
  placeholder,
  isTextArea,
  textAreaProps,
  inputProps,
  ...props
}: MDSTextFieldProps) => {
  return (
    <StyledTextField {...props}>
      <StyledLeftContainer color={props.color}>
        {getSlot(children, MDSTextFieldSlotName.LeftAddon)}
      </StyledLeftContainer>

      {isTextArea ? (
        <TextArea placeholder={placeholder} {...textAreaProps} />
      ) : (
        <Input placeholder={placeholder} {...inputProps} />
      )}

      <StyledRightContainer color={props.color}>
        {getSlot(children, MDSTextFieldSlotName.RightAddon)}
      </StyledRightContainer>
    </StyledTextField>
  );
};
